import { DmrFrame } from 'billing/DmrFrame/DmrFrame';
import { CreditCard } from 'billing/models/CreditCard';
import classNames from 'classnames';
import Button from 'mcs-toolkit/components/Button';
import React, { useEffect, useRef, useState } from 'react';
import { LinkCatalog } from 'system/LinkCatalog';

import { IconWarning } from 'reactComponents/icons/IconWarning';
import { Link } from 'reactComponents/Link/Link';
import Loader from 'reactComponents/loader/Loader';

import styles from './BindCard.css';

type Props = {
    onSuccess(): void;
    onClose(): void;
    isShown: boolean;
};
export function BindCard({ onSuccess, onClose, isShown }: Props) {
    const dmrFrameRef = useRef<HTMLDivElement | null>(null);
    const [error, setError] = useState<null | true | Record<string, string>>(
        null,
    );
    const [isLoading, setIsLoading] = useState(true);
    const [reloadDmrFrameFlag, setReloadDmrFrameFlag] = useState(true);
    const [dmrFrame, setDmrFrame] = useState<null | DmrFrame>(null);

    useEffect(() => {
        if (dmrFrame) {
            dmrFrame.destroy();
        }

        const newDmrFrame =
            dmrFrameRef.current &&
            new DmrFrame({
                el: dmrFrameRef.current,
                className: styles.dmrFrame,
            });
        setDmrFrame(newDmrFrame);
        newDmrFrame && goToPayment(newDmrFrame);

        return () => {
            setDmrFrame(null);
            dmrFrame && dmrFrame.destroy();
        };
    }, [reloadDmrFrameFlag]);

    return (
        <div
            className={classNames(styles.root, {
                [styles.hidden]: !isShown,
            })}
        >
            {error && renderError()}
            {isLoading && <Loader opaque />}
            <div ref={dmrFrameRef} />
        </div>
    );

    function goToPayment(dmrFrame: DmrFrame) {
        dmrFrame.on(DmrFrame.EVENT_PAYMENT_SUCCESS, onSuccess);

        dmrFrame.on(DmrFrame.EVENT_PAYMENT_FAIL, () => {
            setError(true);
        });

        dmrFrame.on(
            DmrFrame.EVENT_CLOSE + ' ' + DmrFrame.EVENT_PAYMENT_CANCEL,
            onClose,
        );

        dmrFrame.on(DmrFrame.EVENT_RETRY, () => {
            insertDmrFrame(dmrFrame);
        });

        return insertDmrFrame(dmrFrame);
    }

    async function insertDmrFrame(dmrFrame: DmrFrame) {
        try {
            setIsLoading(true);
            setError(null);
            const url = await CreditCard.getBindingGateURL();
            await dmrFrame.load(url);
        } catch (error) {
            setError(error);
        } finally {
            setIsLoading(false);
        }
    }

    function renderError() {
        return (
            <div className={styles.error}>
                <IconWarning />
                <h2>Произошла ошибка</h2>
                <div className={styles.text}>
                    Попробуйте перезагрузить страницу или воспользуйтесь
                    сервисом позже.
                </div>
                <div className={styles.description}>
                    В случае возникновения проблем с оплатой вы можете
                    обратиться в{' '}
                    <Link href={LinkCatalog.getInfraSupportEmail()}>
                        службу поддержки
                    </Link>
                </div>
                <Button
                    className={styles.button}
                    primary
                    onClick={() => {
                        setReloadDmrFrameFlag(!reloadDmrFrameFlag);
                    }}
                >
                    Попробовать ещё раз
                </Button>
            </div>
        );
    }
}
